module.exports = __webpack_public_path__ + "img/serveSize.167d6f7b.png";